/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { Helmet } from "react-helmet"
// eslint-disable-next-line import/no-unresolved
import { useLocation } from "@reach/router"
import useBrandInfo from "@hooks/dataHooks/useBrandInfo"

// eslint-disable-next-line no-unused-vars
const SeoResult = ({ title, description, lang, meta, image_url, schema }) => {
  // console.log("image_url =>", image_url)

  const { name } = useBrandInfo()

  const { pathname } = useLocation()

  let currentUrl = ""
  currentUrl = process.env.GATSBY_SITE_URL + pathname

  // set no index for result pagination
  let hasPagination = false
  if (pathname !== undefined && pathname) {
    const pageStr = pathname.split("page-")
    hasPagination = pageStr[1] || false
    console.log("hasPagination", hasPagination)
    if (pageStr[0] !== undefined) {
      currentUrl = process.env.GATSBY_SITE_URL + pageStr[0]
    }
  }

  if (!currentUrl.endsWith("/")) currentUrl += "/"

  // remove multiple slashes
  currentUrl = currentUrl.replace(/([^:]\/)\/+/g, "$1")
  // set lowercase url
  currentUrl = currentUrl.toLowerCase()

  const google_site_meta = process.env.GATSBY_GOOGLE_SITE_VERIFICATION
    ? {
        name: "google-site-verification",
        content: process.env.GATSBY_GOOGLE_SITE_VERIFICATION,
      }
    : ""

  const og_img = image_url
    ? [
        {
          property: "og:image",
          content: image_url,
        },
        {
          property: "og:image:secure_url",
          content: image_url,
        },
        {
          property: "og:image:url",
          content: image_url,
        },
        {
          property: "og:image:type",
          content: "image/jpeg",
        },
        {
          property: "og:image:alt",
          content: title ? `${title} | ${name}` : name,
        },
        {
          name: "twitter:image",
          content: image_url,
        },
      ]
    : ""

  const metaTitle = title

  return (
    <Helmet
      script={[
        {
          type: "application/ld+json",
          innerHTML: `${JSON.stringify(schema)}`,
        },
      ]}
      htmlAttributes={{
        lang,
      }}
      title={metaTitle}
      titleTemplate={`%s | ${name}`}
      link={[
        {
          href: currentUrl,
          rel: "canonical",
        },
      ]}
      meta={[
        {
          name: "description",
          content: description,
        },
        {
          property: "og:title",
          content: `${metaTitle} | ${name}`,
        },
        {
          property: "og:description",
          content: description,
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          property: "og:url",
          content: `${currentUrl}`,
        },
        {
          name: "twitter:creator",
          content: name || "",
        },
        {
          name: "twitter:title",
          content: `${metaTitle} | ${name}`,
        },
        {
          name: "twitter:description",
          content: description,
        },
        {
          name: "twitter:site",
          content: name || "",
        },
        {
          name: "twitter:url",
          content: `${currentUrl}`,
        },
        google_site_meta,
      ]
        .concat(og_img)
        .concat([
          {
            name: "twitter:card",
            content: "summary_large_image",
          },
        ])
        .concat(meta)}
    />
  )
}

SeoResult.defaultProps = {
  lang: "en",
  meta: [],
  description: "",
}

SeoResult.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
}

export default SeoResult
